import Cookies from 'js-cookie'
import mixin from './mixin'
import { getSession, clearSession, setLocal, getLocal } from '@/common/js/api'
import { isArray, isEmpty, deepCopy, trim, getByteLen, pullKeys, timeout } from '@/common/js/utils'

import BatchTable from './components/batch/batch-table'
import SetBatch from './components/batch/set-batch'
import ResultImage from '@/components/convert/result-image'
import { getLandpageData } from '@/api/kuaishou.model'
import { getAudience, getConvertList, getConvert } from '@/api/baidu.model'
import { addBaiduBatchTask } from '@/api/baidu.local.model'
import { getImageLimitRule } from '@/api/common.model'
import { getLogidUrl } from '@/api/manage.model'

import TransFeed from './components/transFeed.vue'

// 反显广告账号
const findAccount = (child, parents) => {
  const findChild = parents.filter((ret) => {
    const childIds = ret.children.map((m) => m.id)
    return childIds.includes(child.id)
  })
  return findChild.shift() || {}
}

// 动态词
const dynwords = ['日期', '时间', '定向包名', '创意组名', '账号简称']

export default {
  name: 'ksLocalBatch',
  mixins: [mixin],
  components: {
    BatchTable,
    SetBatch,
    ResultImage,
    TransFeed
  },
  computed: {
    isCampagin() {
      return this.batch.batch_task_type === 1
    },
    isBatch() {
      return this.tableData.length && this.tableData.length < this.max
    },
    isUnion() {
      return this.union === 'CUSTOM'
    },
    lenAccount() {
      const account = new Set(this.submitData.map((ret) => ret.account.id))
      return account.size
    },
    appType() {
      return this.platform === 1
    },
    tableData() {
      return this.submitData
        .filter((ret) => ret.account.name === this.current)
        .map((ret) => {
          return {
            index: ret.id,
            plan: ret.plan.plan_name,
            dynerr: ret.plan.dyn_err,
            dynpos: ret.plan.dyn_pos,
            account: ret.account.name,
            _account: ret.account._account,
            campaign: ret.campaign.name,
            _campaign: ret.campaign._campaign,
            target: ret.target.targetingName,
            _target: ret.target._target,
            retarget: ret.retarget.name,
            _retarget: ret.retarget._retarget,
            budget: ret.budget.value,
            budgetMode: ret.budget.mode,
            _budget: ret.budget._budget,
            creative: ret.creative.ideaName,
            _creative: ret.creative._creative,
            convert: ret.convert.name,
            _convert: ret.convert._convert,
            pagespec: ret.pagespec && ret.pagespec.name,
            _pagespec: ret.pagespec && ret.pagespec._pagespec
          }
        })
    },
    accountTitle() {
      return (title) => {
        const len = this.submitData.filter((ret) => ret.account.name === title).length
        return `${title}${len ? '(' + len + ')' : ''}`
      }
    }
  },
  data() {
    return {
      miniProgramConvertVisible: false, // 小程序转化弹窗
      miniProgramTransList: [],
      appTransIdByAccount: {},

      miniProgramPageVisible: false, // 小程序落地页弹窗
      miniProgramPageUrl: '',
      miniProgramPageUrlValid: true,

      loading: null,
      auding: null,
      disabled: null,
      union: null,

      ruling: null, // 加载动画
      ruleModel: null, // 素材检测弹窗
      ruleData: [], // 检测结果

      platform: null,
      landing_type: null,
      current: null,
      bat_accounts: [],

      model: null,
      setDisCrowd: null,
      seType: '',
      setData: [], // 待添数据

      num: 1,
      max: 500,
      dynwords: dynwords,
      submitData: [], // 公式结果
      selection: [], // 批量选择
      batch: {
        batch_task_type: 1,
        operation: 'disable'
      }
    }
  },
  methods: {
    initSubmitData() {
      const campaign = getSession('campaign') || {} // 1 批量广告组  2 批量账号
      const account_ids = getSession('ad_account_ids') || []
      const campaign_ids = getSession('campaign_ids') || []
      const targetings = getSession('targetings') || []
      const creativeData = getSession('creative_params') || []
      const converts = getSession('convert_params') || []
      const out_plan_info = getSession('outer_plan_params') || {}
      const plan_info = getSession('inner_plan_params') || {}
      try {
        const { union } = out_plan_info
        const { ch_platform_id, landing_type } = plan_info
        this.union = union
        this.platform = ch_platform_id
        this.landing_type = landing_type
        this.batch.batch_task_type = parseInt(campaign.subject)
        if (isArray(account_ids) && account_ids.length) {
          this.bat_accounts = account_ids
          this.current = account_ids[0].name
        }
        this.sources = {
          subject: campaign,
          account: account_ids,
          campaign: campaign_ids,
          target: targetings,
          creative: creativeData
        }
        // 平铺广告计划
        if (parseInt(campaign.subject) === 1) {
          this.forSubmitGroup({ account_ids, campaign_ids, targetings, creativeData, plan_info, out_plan_info, converts })
        } else if (parseInt(campaign.subject) === 2) {
          this.forSubmitGroup({ campaign, account_ids, targetings, creativeData, plan_info, out_plan_info, converts }, true)
        }
      } catch (err) {
        console.error(err)
      }
    },
    async forSubmitGroup(params, bool = false) {
      const _this = this
      let num = 0
      let group
      const {
        campaign: subject,
        account_ids: account,
        campaign_ids: campaign,
        targetings: target,
        creativeData: creative,
        plan_info: plan,
        out_plan_info: out,
        converts: convert
      } = params
      if (!isArray(account) || !isArray(target) || !isArray(creative)) throw new Error('list must be the array')

      if (bool) group = account // 批量账号
      else {
        // 批量广告组过滤账号
        group = campaign.filter((ret) => {
          const met = findAccount(ret, account)
          return met && met.id
        })
      }
      for (let i = 0; i < group.length; i++) {
        if (num === _this.max) break
        for (let n = 0; n < target.length; n++) {
          if (num === _this.max) break
          for (let m = 0; m < creative.length; m++) {
            if (num === _this.max) break
            let submit = {
              id: num,
              account,
              campaign: bool ? subject : campaign,
              creative: deepCopy(creative[m]),
              plan: Object.assign({}, plan, { plan_name: `${plan.plan_name}_${++num}` }),
              out,
              convert,
              budget: { value: subject.budget, mode: subject.budgetMode }
            }
            if (bool) submit = Object.assign(submit, { account: deepCopy(group[i]) })
            else {
              submit = Object.assign(submit, {
                account: deepCopy(findAccount(group[i], account)),
                campaign: deepCopy(group[i])
              })
            }
            submit = Object.assign(submit, {
              target: deepCopy(target[n])
            })
            // 生成人群包
            const { audiences } = deepCopy(target[n]).targetingParam
            if (isArray(audiences)) {
              const idx = audiences.findIndex((_) => _.account_id === submit.account.id)
              const { retargeting_tags_include, retargeting_tags_exclude } = audiences[idx]
              const retarget_type = retargeting_tags_include.length || retargeting_tags_exclude.length
              submit = Object.assign(submit, {
                retarget: {
                  name: retarget_type ? '已配置' : '未配置人群',
                  audiences: deepCopy(audiences[idx])
                }
              })
            } else {
              submit = Object.assign(submit, {
                retarget: {
                  name: '未配置人群',
                  audiences: {}
                }
              })
            }
            if (isArray(convert)) {
              // 匹配转化追踪
              let convertName = '请配置转化追踪'

              /* 小程序转化 */
              if (plan.landing_type === 'LINK' && plan.ch_platform_id === 3) {
                const [convertItem] = convert.filter((_) => _.accountId === submit.account.id)
                convertName = convertItem.transName

                submit = Object.assign(submit, {
                  convert: Object.assign(
                    {
                      name: convertName
                    },
                    convertItem
                  )
                })
              } else {
                /* 其他转化 */
                const idx = convert.findIndex((_) => _.adAccountId === submit.account.id)
                if (idx > -1) {
                  const { transFromTypeName } = deepCopy(convert[idx])
                  convertName = transFromTypeName
                }
                submit = Object.assign(submit, {
                  convert: Object.assign(
                    {
                      name: convertName
                    },
                    deepCopy(convert[idx])
                  )
                })
              }
            } else {
              submit = Object.assign(submit, {
                convert: Object.assign(
                  {
                    name: '不可配置转化'
                  },
                  convert
                )
              })
            }
            if (this.appType) {
              // 生成落地页
              submit = Object.assign(submit, {
                pagespec: {
                  name: '未配置落地页',
                  page_spec: {}
                }
              })
            }
            // 生成小程序落地页
            if (plan.landing_type === 'LINK' && plan.ch_platform_id === 3) {
              const data = await getLogidUrl({ adAccountId: submit.account.id, gameId: submit.plan.game_id })

              if (data && data.logidUrl) {
                submit = Object.assign(submit, {
                  pagespec: {
                    name: data.logidUrl || '未配置落地页',
                    page_spec: {}
                  }
                })
              }
            }
            _this.submitData.push(submit)
            this.validTrend(num - 1)
          }
        }
      }
    },
    // 动态词验证
    validTrend(index) {
      if (typeof index !== 'number') return
      const { plan_name } = deepCopy(this.submitData[index].plan)
      if (isEmpty(plan_name)) return
      let dynErr = ''
      const regexp = /({[\u4e00-\u9fa5]{2,}})/g
      const values = plan_name.match(regexp)
      const count = (str, cut) => {
        if (typeof str !== 'string') return 0
        return str.split('').filter((ret) => ret === cut).length
      }
      if (count(plan_name, '{') !== count(plan_name, '}')) {
        dynErr = '动态词包格式错误'
      } else if (plan_name.replace(regexp, '').includes('{') || plan_name.replace(regexp, '').includes('{')) {
        dynErr = '动态词包标识{}不允许作为内容出现'
      } else if (isArray(values) && values.some((ret) => !this.dynwords.map((met) => `{${met}}`).includes(ret))) {
        dynErr = '动态词包不存在'
      } else if (isArray(values) && values.some((ret, i) => values.indexOf(ret) !== i)) {
        dynErr = '动态词包不能存在相同'
      }
      // 动态词位置
      let dynPos = []
      if (isArray(values)) {
        dynPos = values
          .filter((ret) => this.dynwords.map((met) => `{${met}}`).includes(ret))
          .map((m) => {
            const min = plan_name.indexOf(m)
            return [min, min + m.length]
          })
      }
      this.$set(this.submitData[index].plan, 'dyn_pos', dynPos)
      this.$set(this.submitData[index].plan, 'dyn_err', dynErr)
    },
    changeInputLen(val) {
      const [index, value] = val
      const idx = this.submitData.findIndex((ret) => ret.id === index)
      this.$set(this.submitData[idx].plan, 'plan_name', value)
      this.validTrend(idx)
    },
    batchAll(val) {
      const [type, index] = val
      const idx = this.submitData.findIndex((ret) => ret.id === index)
      if (typeof index === 'number' && idx > -1) {
        // 单项修改
        const filter = this.submitData[idx]
        const account = filter.account.id
        const convert = filter.convert
        const { newInterests, keywords } = filter.target.targetingParam
        const disCrowd = (isArray(newInterests) && newInterests.length) || (isArray(keywords) && keywords.length)
        const pageId = filter.pagespec && filter.pagespec.page_spec && filter.pagespec.page_spec.page_id
        this.filters = [filter]
        if (['retarget', 'convert', 'pagespec'].includes(type)) {
          if (typeof account !== 'number') {
            this.$Message.error('请先设置计划账号')
            return
          }
          if (type === 'retarget') this.getAudienceData(account, type, disCrowd)
          else if (type === 'convert') this.getConverterData(convert, type)
          else if (type === 'pagespec') this.getPagespecData(filter)
        } else if (type === 'budget') {
          const [, , budget] = val
          if (typeof budget === 'number') this.$set(filter, 'budget', Object.assign(filter.budget, { value: budget }))
          else if (typeof budget === 'string') {
            let curBudget
            if (budget === 'BUDGET' && !filter.budget.value) curBudget = { value: 50, mode: 1 }
            else curBudget = { value: 0, mode: 0 }
            this.$set(filter, 'budget', Object.assign(filter.budget, curBudget))
          }
        } else {
          if (type === 'campaign') this.setData = this.sources[type].filter((ret) => ret.account === account)
          else this.setData = this.sources[type]
          this.model = true // 弹窗
          this.seType = type
        }
      } else {
        // 批量修改
        const filters = this.submitData.filter((ret) => ret[type][`_${type}`])
        if (!filters.length) {
          this.$Message.error('至少选择一项')
          return
        }
        // 批量广告组与人群包统一账号
        const account = filters[0].account.id
        const convert = filters[0].convert
        const disCrowd = filters.some((ret) => {
          const { newInterests, keywords } = ret.target.targetingParam
          return (isArray(newInterests) && newInterests.length) || (isArray(keywords) && keywords.length)
        })
        const sameAccount = filters.every((ret) => ret.account.id === account)
        if (['campaign', 'retarget', 'convert', 'pagespec'].includes(type) && !sameAccount) {
          this.$Message.error('请选择同一个账号的计划进行批量设置')
          return
        }
        this.filters = filters
        if (type === 'retarget') this.getAudienceData(account, type, disCrowd)
        else if (type === 'convert') this.getConverterData(convert, type)
        else if (type === 'pagespec') this.getPagespecData()
        else {
          if (type === 'campaign') this.setData = this.sources[type].filter((ret) => ret.account === filters[0].account.id)
          else if (type === 'budget') {
            if (filters.length > 1) this.setData = [{ value: 3000, mode: 1 }]
            else if (filters.length === 1) {
              const { budget } = filters[0]
              const { value, mode } = budget
              this.setData = [{ value, mode }]
            }
          } else this.setData = this.sources[type]
          this.model = true // 弹窗
          this.seType = type
        }
      }
    },
    batchAdd() {
      const len = this.submitData.length
      const more = this.max - this.tableData.length
      const num = more > 50 ? this.num : more % 50
      const table = this.submitData.filter((ret) => ret.account.name === this.current).pop()
      if (!table || !len) {
        this.$Message.error('无计划不能批量复制！')
        return
      }
      const index = this.submitData.findIndex((ret) => ret.id === table.id)
      const { id } = this.submitData[len - 1]
      const { account, campaign, target, retarget, creative, pagespec, plan, dynerr, out, convert, budget } = deepCopy(
        this.submitData[index]
      )
      const { plan_name } = plan
      for (let i = 0; i < num; i++) {
        this.submitData.push({
          id: id + i + 1,
          account: deepCopy(account),
          campaign: deepCopy(campaign),
          target: deepCopy(target),
          retarget: deepCopy(retarget),
          creative: deepCopy(creative),
          pagespec: deepCopy(pagespec),
          budget: deepCopy(budget),
          out: deepCopy(out),
          convert: deepCopy(convert),
          dynerr: deepCopy(dynerr),
          plan: Object.assign({}, plan, { plan_name: `${plan_name}_${i + 1}` })
        })
      }
    },
    batchDel() {
      const len = this.selection.length
      if (!len) {
        this.$Message.error('至少选中一条计划')
        return
      }
      this.$Modal.confirm({
        title: '系统提示',
        content: `当前选中${len}条计划，确认删除？`,
        onOk: () => {
          const ids = this.selection.map((ret) => ret.index)
          this.submitData = this.submitData.filter((ret) => !ids.includes(ret.id))
        }
      })
    },
    selectAll({ type, val }) {
      this.submitData
        .filter((ret) => ret.account.name === this.current)
        .forEach((ret) => {
          this.$set(ret[type], `_${type}`, val)
        })
    },
    selectCheckBox({ type, val }) {
      const [index, bool] = val
      const idx = this.submitData.findIndex((ret) => ret.id === index)
      this.$set(this.submitData[idx][type], `_${type}`, bool)
    },
    copySubmit(index) {
      if (!this.isBatch) {
        this.$Message.error('计划数已达到了上限')
        return
      }
      const len = this.submitData.length
      const unshife = deepCopy(this.submitData.filter((ret) => ret.account.name === this.current)[index])
      const { id } = this.submitData[len - 1]
      unshife.id = id + 1
      unshife.plan = Object.assign(unshife.plan, { plan_name: `${unshife.plan.plan_name}复制` })
      this.submitData.push(unshife)
    },
    delSubmit(id) {
      const index = this.submitData.findIndex((ret) => ret.id === id)
      this.submitData.splice(index, 1)
    },
    asynSetBatch({ type, index }) {
      // 批量操作结果
      if (typeof type !== 'string' || (!['budget', 'bid'].includes(type) && typeof index !== 'number')) {
        this.$Message.error('选择的类型或是值错误')
        return
      }

      if (type === 'retarget') {
        // 人群包修改
        const includes = []
        const excludes = []
        const account = this.filters[0].account.id
        const retarget_type = this.setData.some((ret) => {
          return ret.select === 'include' || ret.select === 'exclude'
        })
        if (retarget_type) {
          const include = this.setData.filter((met) => met.select === 'include').map((ret) => ret.id)
          const exclude = this.setData.filter((met) => met.select === 'exclude').map((ret) => ret.id)
          includes.push(...include)
          excludes.push(...exclude)
        }
        // 批量更改定向
        this.filters.forEach((ret) => {
          const re_name = excludes.length || includes.length ? '已配置' : '未配置人群'
          const re_audiences = { account_id: account, retargeting_tags_exclude: excludes, retargeting_tags_include: includes }
          this.$set(ret, 'retarget', { name: re_name, audiences: re_audiences })
          this.$set(ret, '_retarget', false)
        })
      } else if (type === 'convert') {
        // 转化追踪
        const nVal = deepCopy(this.setData[index])
        if (!nVal || !nVal.value) {
          this.$Message.error('选中转化追踪数据不可用')
          return
        }
        const { transFromTypeName } = nVal
        nVal.name = transFromTypeName
        nVal._convert = false
        this.filters.forEach((ret) => {
          this.$set(ret, 'convert', Object.assign({}, ret.convert, nVal))
        })
      } else if (type === 'account') {
        // 账号修改
        // 批量更改账号，广告组，人群包
        const old_account = this.filters[0].account.id
        this.filters.forEach((ret) => {
          const account = deepCopy(this.setData[index])
          if (account.id !== old_account) {
            this.$set(ret, 'campaign', {})
            this.$set(ret, 'retarget', {
              name: '未配置人群',
              audiences: { account_id: account.id, retargeting_tags_exclude: [], retargeting_tags_include: [] }
            })
            if (this.appType) this.$set(ret, 'pagespec', { name: '未配置落地页', page_spec: {} }) // 修改落地页
            this.$set(ret, type, account)
          }
          this.$set(ret[type], `_${type}`, false)
        })
      } else if (type === 'budget') {
        this.filters.forEach((ret) => {
          const {
            budget,
            out: { cpa_bid, deep_conversion_bid }
          } = deepCopy(ret)
          const bid = cpa_bid || deep_conversion_bid
          if (index.mode === 'BUDGET' && index.value < bid) {
            this.$Message.error(`预算不能低计划组出价${bid}！`)
            return
          }
          Object.assign(budget, index)
          this.$set(ret, type, budget)
          this.$set(ret[type], `_${type}`, false)
        })
      } else if (type === 'pagespec') {
        let page_spec
        if (typeof index === 'number') {
          const nVal = deepCopy(this.setData[index])
          page_spec = { name: nVal.page_name, page_spec: nVal }
        } else if (typeof index === 'object') {
          const { index: idx, override } = index
          const nVal = deepCopy(this.setData[idx])
          page_spec = { name: nVal.page_name, page_spec: Object.assign({}, nVal, { override_canvas_head_option: override }) }
        } else {
          page_spec = { name: '未配置落地页', page_spec: {} }
        }
        this.filters.forEach((ret) => {
          this.$set(ret, type, deepCopy(page_spec))
          this.$set(ret[type], `_${type}`, false)
        })
      } else {
        const nVal = deepCopy(this.setData[index])
        if (!nVal) {
          this.$Message.error('找不到选中值数据')
          return
        }
        this.filters.forEach((ret) => {
          this.$set(ret, type, deepCopy(nVal))
          this.$set(ret[type], `_${type}`, false)
        })
      }
    },
    deleteSetData({ type, name }) {
      if (type === 'retarget') {
        const index = this.setData.findIndex((ret) => ret.id === name)
        if (index > -1) {
          this.$set(this.setData[index], 'select', null)
        }
      }
    },
    clearSetData({ type }) {
      if (type === 'retarget') {
        this.setData.forEach((item) => {
          this.$set(item, 'select', null)
        })
      }
    },
    getAudienceData(account, type, disCrowd) {
      this.auding = true
      getAudience({ ad_account_id: account })
        .then((data) => {
          if (typeof data !== 'symbol') this.auding = false
          if (isArray(data)) {
            // 单个显示
            let includes = []
            let excludes = []
            if (isArray(this.filters) && this.filters.length === 1) {
              const [filter] = this.filters
              const { retargeting_tags_include, retargeting_tags_exclude } = filter.retarget.audiences || {}
              if (isArray(retargeting_tags_include)) includes = retargeting_tags_include
              if (isArray(retargeting_tags_exclude)) excludes = retargeting_tags_exclude
            }
            this.setData = data
              .filter((ret) => ret.groupStatus === 'finished')
              .map((ret) => {
                let select
                includes.includes(ret.groupId) && (select = 'include')
                excludes.includes(ret.groupId) && (select = 'exclude')
                return {
                  id: ret.groupId,
                  name: ret.groupName,
                  type: ret.groupTypeDesc,
                  count: ret.groupCount,
                  select
                }
              })

            this.model = true // 弹窗
            this.seType = type
            this.setDisCrowd = !!disCrowd
          } else this.setData = []
        })
        .catch((err) => {
          this.auding = false
          console.error(err)
        })
    },
    getConvertByAccount(ad_account_id) {
      getConvert({ transFrom: 7, ad_account_id }).then((data) => {
        this.miniProgramTransList = data
      })
    },
    onMiniProgramConvertCancel() {
      this.miniProgramConvertVisible = false
      this.appTransIdByAccount = {}
    },
    onMiniProgramConvertConfirm() {
      this.filters.forEach((ret) => {
        const newConvert = this.appTransIdByAccount[ret.account.id]
        this.$set(ret, 'convert', Object.assign({}, ret.convert, { ...newConvert, name: newConvert.transName }))
      })

      this.onMiniProgramConvertCancel()
    },
    getConverterData(convert, type) {
      if (!convert) {
        this.$Message.error('请求转化信息错误')
        return
      }

      /* 小程序转化 */
      if (convert.appTransId) {
        this.getConvertByAccount(convert.accountId)
        this.miniProgramConvertVisible = true
      } else {
        const { adAccountId, platform, gameId, downloadUrl, apkName, transFrom, transFromType } = convert
        this.$Spin.show()
        this.auding = true
        getConvertList({
          accountIds: [adAccountId],
          platform: platform,
          downloadUrl: downloadUrl,
          apkName: apkName,
          game_id: gameId
        }).then((data) => {
          this.auding = false
          this.$Spin.hide()
          if (isArray(data)) {
            this.setData = data.map((ret) => {
              ret.check = ret.transFrom === transFrom && ret.transFromType === transFromType
              return ret
            })
            this.model = true // 弹窗
            this.seType = type
          } else this.setData = []
        })
      }
    },
    onMiniProgramPageCancel() {
      this.miniProgramPageVisible = false
      this.miniProgramPageUrlValid = true
      this.miniProgramPageUrl = ''
    },
    onMiniProgramPageConfirm() {
      const isUrl = /^(?:http(s)?:\/\/)/.test(this.miniProgramPageUrl)
      if (!isUrl) {
        this.miniProgramPageUrlValid = false
        return
      }
      this.filters.forEach((ret) => {
        this.$set(ret, 'pagespec', Object.assign({}, ret.pagespec, { name: this.miniProgramPageUrl }))
      })

      this.onMiniProgramPageCancel()
    },
    getPagespecData(row) {
      const { pagespec } = row || {}
      this.miniProgramPageVisible = true
      this.miniProgramPageUrl = pagespec?.name || ''
    },
    appendTrend(val) {
      const [index, word, selectionStart] = val
      const idx = this.submitData.findIndex((ret) => ret.id === index)
      const title = deepCopy(this.submitData[idx].plan.plan_name)
      const prefix = title.substring(0, selectionStart)
      const suffix = title.substring(selectionStart)
      const value = `${prefix}{${word}}${suffix}`
      if (title.indexOf(word) > -1) {
        this.$Message.error('不能使用重复的动态词')
        return
      }
      this.$set(this.submitData[idx].plan, 'plan_name', value)
      this.validTrend(idx)
    },
    delTrend(index) {
      const idx = this.submitData.findIndex((ret) => ret.id === index)
      this.validTrend(idx)
    },
    changeSelection(val) {
      this.selection = val
    },
    changeTabs() {
      this.submitData.forEach((ret) => {
        ;['account', 'campaign', 'target', 'creative', 'retarget', 'budget', 'pagespec'].forEach((type) => {
          if (ret[type]) {
            this.$set(ret[type], `_${type}`, false)
          }
        })
      })
    },
    changeBudget(index) {
      const idx = this.submitData.findIndex((ret) => ret.id === index)
      const { ocpcBid, deepOcpcBid } = this.submitData[idx].out
      const bid = deepOcpcBid || ocpcBid
      if (this.submitData[idx].budget.value && this.submitData[idx].budget.value < bid) {
        this.$Message.error(`预算不能低于推广单元出价${bid}！`)
      }
    },
    customVaild(data) {
      const err = []
      // 导出title组
      data.forEach((ret) => {
        const title = ret.plan.plan_name
        const dyneer = ret.plan.dyn_err
        const idx = err.findIndex((ret) => ret.title === trim(title))
        if (idx > -1) err[idx].ids.push(ret.id)
        else err.push({ title: trim(title), dyneer, ids: [ret.id] })
      })
      const empties = err.filter((ret) => isEmpty(ret.title))
      const sames = err.filter((ret) => ret.title && ret.ids.length > 1)
      const mores = err.filter((ret) => {
        let len = getByteLen(ret.title)
        const regexp = /({[\u4e00-\u9fa5]{2,}})/g
        const values = ret.title.match(regexp)

        if (isArray(values)) {
          values.forEach((ret) => {
            ret === '{定向包名}' && (len += 11)
            ret === '{创意组名}' && (len += 11)
          })
        }
        return len > 90
      })
      const dyerrors = err.filter((ret) => ret.dyneer)
      return [empties, sames, mores, dyerrors]
    },
    back() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>您正在编辑内容，离开将放弃原来的批量操作，确定要退出吗？</p>',
        loading: true,
        okText: '是',
        cancelText: '否',
        onOk: () => {
          timeout(300).then(() => {
            this.$Modal.remove()
            this.$router.push({
              name: 'baidulocalidea',
              query: { t: 'edit' }
            })
          })
        }
      })
    },
    submit() {
      const errRes = this.customVaild(this.submitData)
      if (errRes.some((_) => _.length)) {
        const content = errRes.map((ret, i) => {
          let profix = ''
          if (i === 1) profix = '计划名称不能相同'
          else if (i === 2) profix = '计划名称不能超过90个字符'
          else if (i === 3) profix = '计划名称中动态词规则错误'
          else profix = '计划名称不能为空'
          if (isArray(ret) && ret.length) {
            const ids = ret.map((ret) => ret.ids.map((_) => _ + 1).join(',')).join(',')
            return `<p style="word-break:break-all">${profix}，请检查以下序号的计划：${ids}</p>`
          } else return ''
        })
        this.$Modal.error({
          title: '批量计划错误，请修改：',
          content: content.join('')
        })
        // 如果错误中断
        return
      }

      /* 小程序验证落地页，必须配置落地页 */
      try {
        this.submitData.forEach((res, index) => {
          if (res.pagespec && res.plan.ch_platform_id === 3) {
            if (res.pagespec.name.includes('未配置落地页')) {
              throw new Error(`账号：${res.account.name} 序号：${index + 1}未配置落地页`)
            }
          }
        })
      } catch (e) {
        this.$Modal.error({
          title: '批量计划错误，请修改：',
          content: e.message
        })

        return
      }

      this.validLimitRule()
    },
    validLimitRule() {
      if (!this.submitData.length) {
        this.$Message.error('当前未创建计划不能提交！')
        return
      }
      this.ruleModel = true
      this.ruling = true
      // 智能检测
      getImageLimitRule({
        mediaId: this.media,
        gameId: this.submitData[0].plan.game_id,
        planList: this.submitData.map((ret) => {
          const {
            plan: { plan_name }
          } = ret
          const {
            creative: {
              elements: { singlePic, largePic, package3Pic, horizontalVideos, verticalVideos }
            }
          } = ret
          const videoElement = [...horizontalVideos, ...verticalVideos].map((met) => met.split(' ')[0])
          const imageElement = [...horizontalVideos, ...verticalVideos].map((met) => met.split(' ')[1])
          const packageElement = package3Pic.map((met) => met.split(' ')).flat()
          return {
            planId: ret.id,
            planName: plan_name,
            imageIds: [
              { imageId: [...singlePic, ...largePic, ...imageElement, ...packageElement].join(','), videoId: videoElement.join(',') }
            ]
          }
        })
      })
        .then((data) => {
          if (isArray(data)) this.ruleData = data
          this.ruling = false
        })
        .catch(() => {
          this.ruling = false
        })
    },
    postAdvicest() {
      const advs = this.ruleData.filter((ret) => ret.advice).map((ret) => ret.planId)
      this.postRequest(advs)
    },
    postRequest(advs) {
      this.ruleModel = false
      let submitData = this.submitData
      if (advs) submitData = this.submitData.filter((ret) => advs.includes(ret.id))
      const params = Object.assign(this.batch, {
        planlist: submitData.map((ret) => {
          const campaign = { subject: ret.campaign.promoted_object_type }
          const creative = {}
          const {
            union,
            bidtype,
            innerUrl,
            lpUrl,
            transType,
            transTypeAttribute,
            ocpcLevel,
            // bid,
            bid_range,
            bid_num_range,
            ocpcBid,
            optimizeDeepTrans,
            deepTransType,
            useRoi,
            roiRatio,
            deep_bid_mode,
            deep_bid_range,
            deep_deepbid_num_range,
            deepOcpcBid
          } = ret.out

          const ocpc = {
            innerUrl,
            lpUrl,
            transType,
            ocpcLevel,
            bid_range,
            bid_num_range,
            ocpcBid,
            deep_bid_mode
          }

          const { landing_type, ch_platform_id } = ret.plan
          /* 为小程序配置推广页 */
          if (landing_type === 'LINK' && ch_platform_id === 3) {
            ocpc.lpUrl = ret.pagespec.name
            ocpc.innerUrl = false
          }
          if (transTypeAttribute) {
            // 20221128更改： 勾选优化付费次数  https://dev2.baidu.com/content?sceneType=0&pageId=103354&nodeId=1281&subhead=
            ocpc.transTypeAttribute = 2
          }

          const { value, mode } = ret.budget
          const { targetingParam } = ret.target
          Object.assign(campaign, { budgetMode: mode, budget: mode ? value : 0 }) // 预算更改
          Object.assign(targetingParam, { audiences: ret.retarget.audiences }) // 人群包更新
          useRoi && Object.assign(ocpc, { useRoi, roiRatio })
          optimizeDeepTrans &&
            Object.assign(ocpc, { optimizeDeepTrans, deepTransType, deep_bid_range, deep_deepbid_num_range, deepOcpcBid })
          // if (ret.pagespec) {
          //   // 合并落地页
          //   const { page_spec } = ret.pagespec
          //   if (page_spec && page_spec.page_id) Object.assign(creative, { site_id: page_spec.page_id })
          // }
          if (!ret.creative.producttypes) Object.assign(creative, { producttypes: [] })
          ret.campaign = Object.assign({}, ret.campaign, campaign)
          ret.out = {
            bidtype,
            union,
            ocpc
          }
          ret.creative = Object.assign({}, ret.creative, creative)
          ret.target = Object.assign({}, ret.target, { targetingParam })
          let param = {
            inner_plan_params: ret.plan,
            outer_plan_params: ret.out,
            creative_params: ret.creative,
            convert_params: ret.convert,
            targetings: this.paramsAdjustment(deepCopy(ret.target)) // 参数结构调整
          }
          if (this.batch.batch_task_type === 1) {
            param = Object.assign(param, {
              campaign_id: ret.campaign.id,
              ad_account_id: ret.account.id
            })
          } else param = Object.assign(param, { ad_account_id: ret.account.id, campaign_params: ret.campaign })
          return param
        })
      })
      this.loading = true
      addBaiduBatchTask(params).then((data) => {
        if (typeof data !== 'symbol') this.loading = false
        if (data) {
          clearSession()
          this.setOperatorStorage('operation', params.operation)
          this.disabled = true
          this.$Message.info({
            content: '提交成功！页面将 2 秒后自动关闭',
            duration: 2,
            onClose: () => {
              window.close()
            }
          })
        }
      })
    },
    paramsAdjustment(target) {
      const pullArray = []
      const {
        district,
        region,
        ageMode,
        age,
        customAge,
        appType,
        app,
        mult_app,
        appBehavior,
        keywords,
        newInterests,
        lifeStage,
        education,
        iosVersion,
        androidVersion
      } = target.targetingParam
      const appParam = { type: appType }
      if (this.isUnion) {
        // 百青藤
        pullArray.push(
          ...[
            'region',
            'age',
            'gender',
            'android_osv',
            'ios_osv',
            'device_brand',
            'device_price',
            'network',
            'behavior_type',
            'behavior_interest',
            'audiences'
          ]
        )
      } else {
        pullArray.push(
          ...[
            'region',
            'sex',
            'age',
            'customAge',
            'newInterests',
            'keywords',
            'keywordsExtend',
            'app',
            'audiences',
            'device',
            'iosVersion',
            'androidVersion',
            'net',
            'lifeStage',
            'education',
            'autoExpansion',
            'excludeTrans'
          ]
        )
      }
      if (district === 'NONE') target.targetingParam.region = '9999999'
      else target.targetingParam.region = region.join(',')

      if (appType === 'category' && app?.length) {
        Object.assign(appParam, {
          list: app.map((ret) => {
            return { id: ret.id }
          }),
          behavior: [appBehavior]
        })
      }

      if (appType === 'custom' && mult_app?.length) {
        Object.assign(appParam, {
          list: mult_app.map((ret) => {
            return { id: ret.id, name: ret.name }
          }),
          behavior: [appBehavior]
        })
      }

      if (appType === 'all') {
        Object.assign(appParam, { type: 'all' })
      }

      target.targetingParam.age = isArray(age) && age.length ? age.join(',') : '0'
      if (ageMode === 'CUSTOM') {
        target.targetingParam.age = undefined
        target.targetingParam.customAge = isArray(customAge) && customAge.length ? customAge.join(',') : '0'
      }
      target.targetingParam.newInterests = isArray(newInterests) && newInterests.length ? newInterests.join(',') : '0'
      target.targetingParam.keywords = isArray(keywords) && keywords.length ? keywords.join(',') : ''
      target.targetingParam.lifeStage = isArray(lifeStage) ? lifeStage.join(',') : lifeStage
      target.targetingParam.education = isArray(education) ? education.join(',') : education
      target.targetingParam.iosVersion = isArray(iosVersion) ? iosVersion.join(',') : iosVersion
      target.targetingParam.androidVersion = isArray(androidVersion) ? androidVersion.join(',') : androidVersion
      target.targetingParam.app = JSON.stringify(appParam)
      target.targetingParam = pullKeys(pullArray, target.targetingParam)
      return target
    },
    getOperation() {
      const account = Cookies.get('ch_op_id') || ''
      const storage = getLocal('operation')
      const operation = storage && account && storage[account] ? storage[account] : this.batch.operation
      this.$set(this.batch, 'operation', operation)
    },
    setOperatorStorage(name, value) {
      const account = Cookies.get('ch_op_id')
      const storage = getLocal(name) || {}
      if (account) {
        storage[account] = value
        setLocal(name, storage)
      }
    }
  },
  watch: {
    submitData: {
      handler(nVal) {
        console.log(nVal)
      },
      deep: true
    }
  },
  created() {
    this.getOperation()
    this.initSubmitData()
  }
}
